import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";

const DeservantsChart = (props) => {
  const [chartData, setChartData] = useState(null);

  const COLORS = [
    "#FF6384", // Coral Red
    "#36A2EB", // Bright Blue
    "#FFCE56", // Yellow
    "#4BC0C0", // Teal
    "#9966FF", // Purple
    "#FF9F40", // Orange
    "#2ECC71", // Green
    "#E74C3C", // Deep Red
    "#34495E", // Navy
    "#8E44AD", // Dark Purple
  ];

  useEffect(() => {
    if (props.occupationData && props.occupationData.length > 0) {
      const labels = props.occupationData.map(
        (item) => item.occupation || "Unknown"
      );
      const counts = props.occupationData.map((item) => item.count || 0);

      setChartData({
        labels: labels,
        datasets: [
          {
            data: counts,
            backgroundColor: COLORS.slice(0, labels.length),
          },
        ],
      });
    }
  }, [props.occupationData]);

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 0.7,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
            return `${label}: ${value} (${pct}%)`;
          },
        },
      },
      datalabels: {
        color: "#f3f6f4",
        font: {
          size: "13px",
          weight: "600",
        },
        formatter: function (value) {
          return value > 0 ? value : "";
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "#495057",
          padding: 12,
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <div className="layout-main-height">
      <div className="datatable-doc-demo">
        <div className="card-1">
          <Chart
            type="doughnut"
            data={chartData}
            options={options}
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
    </div>
  );
};

export default DeservantsChart;
